// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container .active[data-v-4d0603d6] {\n  color: #cb582e !important;\n}\n.container .title[data-v-4d0603d6] {\n  text-align: center;\n  font-size: 0.2rem;\n  color: #cb582e;\n  margin-bottom: 0.24rem;\n}\n", ""]);
// Exports
module.exports = exports;
